import useTranslation from '../../hooks/useTranslation'
import SlideInView from '../../UI/SlideInView/SlideInView'
import Container from '../../UI/Container/Container'
import AnalyseContent from './AnalyseContent'
import BuildContent from './BuildContent'
import DefaultContent from './DefaultContent'
import DesignContent from './DesignContent'

export type IntroActiveId = null | 'analyse' | 'design' | 'build'

const contentMap = {
  default: DefaultContent,
  analyse: AnalyseContent,
  design: DesignContent,
  build: BuildContent,
} as const

const INTRO_TAB_IDS: Array<Exclude<IntroActiveId, null>> = ['analyse', 'design', 'build']

type IntroProps = {
  activeId: IntroActiveId
  setActiveId: (id: IntroActiveId) => void
}

const Intro = ({ activeId, setActiveId }: IntroProps) => {
  const t = useTranslation()
  const introLabels = { analyse: t.landing.intro.analyse.label, design: t.landing.intro.design.label, build: t.landing.intro.build.label }
  const key = activeId ?? 'default'
  const ContentComponent = contentMap[key]

  const toggleActiveId = (tabId: IntroActiveId) => {
    if (activeId === tabId) {
      setActiveId(null)
      return
    } else {
      setActiveId(tabId)
    }
  }

  return (
    <div id="intro" className="h-fit pt-44 md:pt-44 pb-10 flex items-center justify-center">
      <div className="w-full">
        <Container>
          <SlideInView>
            <div className="flex flex-col gap-10 md:flex-row md:items-start md:gap-0">
              {/* Left: Analyse / Design / Build */}
              <div className="flex shrink-0 md:flex-col gap-4 sm:gap-5 md:gap-6 md:w-1/3">
                {INTRO_TAB_IDS.map((tabId) => (
                  <div
                    key={tabId}
                    onClick={() => toggleActiveId(tabId)}
                    className={`cursor-pointer text-left text-2xl font-bold sm:text-3xl md:text-[4rem] md:leading-[4rem] lg:text-[4.5rem] lg:leading-[4.5rem] xl:text-[5.3rem] ${
                      activeId === tabId ? 'text-neonYellow' : 'text-blue hover:text-neonYellow'
                    }`}
                  >
                    {introLabels[tabId]}
                  </div>
                ))}
              </div>

              {/* Right: unified content renderer */}
              <div className="flex min-w-0 flex-1 flex-col md:w-2/3 md:pt-3">
                <ContentComponent />
              </div>
            </div>
          </SlideInView>
        </Container>
      </div>
    </div>
  )
}

export default Intro
